import { render } from "./Kitchen.vue?vue&type=template&id=c473ebe0&scoped=true"
import script from "./Kitchen.vue?vue&type=script&lang=js"
export * from "./Kitchen.vue?vue&type=script&lang=js"

import "./Kitchen.vue?vue&type=style&index=0&id=c473ebe0&lang=less&scoped=true"

import exportComponent from "/home/bula/demo/bula2023/vue/bula2023/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c473ebe0"]])

export default __exports__